module.exports = __webpack_public_path__ + "img/img36.d370c833.svg";